module.exports = __webpack_public_path__ + "static/media/buypower-logo.f1a37804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buypower-logo.png
// module id = 84
// module chunks = 25